import { useNavigate, useSearch } from '@tanstack/react-router';

import type {
  PlacementSortDirection,
  PlacementSortProperty,
  PlacementStatus,
  PlacementType,
} from './model';
import {
  parsePlacementsRouteSearch,
  serializePlacementsRouteSearch,
} from './placementsRouteSearch';

export function usePlacementsRouteFilters() {
  const navigate = useNavigate({ from: '/supply/placements' });
  const search = useSearch({ from: '/supply/placements' });
  const filter = parsePlacementsRouteSearch(search);
  const update = (next: typeof filter) =>
    void navigate({ search: serializePlacementsRouteSearch(next), replace: true });
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: PlacementStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setTypes: (types: PlacementType[]) => {
      update({ ...filter, types, page: 0 });
    },
    setSort: (
      sortProperty: PlacementSortProperty | null,
      sortDirection: PlacementSortDirection,
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page: size === filter.size ? page : 0, size });
    },
  };
}
